import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import GenderForm from "./Form";
import { GenderColumns } from "../../../../data/Columns/SystemSetupColumns";
import { gender } from "../../../../data/Queries/SetupManagement/SystemSetupQueries";
import { setupManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";



const base_url = setupManagementUrl.uri;
const actions = {
  entity: "Gender",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
};
function Gender() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Gender"
          subtitle="Manage Gender"
          columns={GenderColumns}
          FormComponent={GenderForm}
          query={gender}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default Gender;